export const NATIVE_APP_PLATFORMS = {
  IOS: 'ios',
  ANDROID: 'android',
};

export const NATIVE_APP_NOT_AVAILABLE_VERSION = 'n/a';
